import {useContext} from 'react'
import {CustomLanding36252Context} from '../../reducer'
import {InnerSection} from '../InnerSection'
import {t} from '../../i18n'
import {Container} from './components/Container'
import {WhiteNotification} from './components/WhiteNotification'
import {Bold} from './components/Bold'
import {ReactComponent as MauritiusFlag} from '../../assets/flag.svg'
import {Header} from '../TermsAndConditions/components/Header'
import {Normal} from '../TermsAndConditions/components/Normal'
import {Column} from './components/Column'
import {Copyright} from './components/Copyright'

export const Disclaimers = () => {
  const [state] = useContext(CustomLanding36252Context)
  const tr = t[state.language]

  return (
    <Container>
      <InnerSection>
        <Column>
          <WhiteNotification inverse={state.language === 'ar'}>
            {tr.regulatedByFooter}
            <Bold>&nbsp;{tr.fsc}</Bold>
            <MauritiusFlag />
            {tr.mauritius}
            &nbsp; C208180
          </WhiteNotification>
          <Header>{tr.riskHead1}</Header>
          <Normal>{tr.riskPara1}</Normal>
          <Header>{tr.riskHead2}</Header>
          <Normal>{tr.riskPara2}</Normal>
          <Header>{tr.riskHead3}</Header>
          <Normal>{tr.riskPara3}</Normal>
          <br />
          <Normal>
            {tr.pleaseReview}{' '}
            <a style={{textDecoration: 'underline'}} href="https://www.mau.tauromarkets.com/legal-documents">
              {tr.here}
            </a>
          </Normal>
          <Normal>
            {tr.forComplaints}{' '}
            <a style={{textDecoration: 'underline'}} href="mailto:complaints@mau.tauromarkets.com">
              complaints@mau.tauromarkets.com
            </a>
          </Normal>
          <Copyright>{t[state.language].copyright}</Copyright>
        </Column>
      </InnerSection>
    </Container>
  )
}
